import { videoJsCode } from '../utils/func.js'
const modalContainer = $('#exit-survey-modal-b')
const questionBlock = $('#trackingsurvey-question-block')
const triggerInput = questionBlock.find('input')

export function exitSurveySelect() {
  $.each(triggerInput, (index, val) => {
    const order = index + 1
    const targetDiv = $('#trackingsurvey-answer' + order + '-block')

    $(val).on('change', event => {
      if ($(val).prop('checked')) {
        if ($(val).attr('href')) {
          window.location.href = $(val).attr('href')
          closeExitSurvey()
        } else {
          // modalContainer.removeClass('exit-survey-b-bg')
          // modalContainer.addClass('answer-bg')
          targetDiv.show()
          $('#answer-block-wrapper .answer-block')
            .not(targetDiv)
            .hide()
          $('.exit-survey-item-block')
            .not($(val).parent())
            .hide()
          $('.exit-survey-tip').hide()
          $(val)
            .parent()
            .addClass('active')
        }
      } else {
        $(val)
          .parent()
          .removeClass('active')
      }
    })

    $(val).on('click', event => {
      if ($(val).prop('checked') && $(val).attr('href')) {
        // redirect triggered, do nothing
      } else {
        $('.modal-title').hide()
      }
    })
  })
}

export function backContent() {}

export function showConfirmBox() {
  if (needSeatingChart === true) {
    $('.exit-survey-confirm-block').addClass('has-seats-block')
  }

  if ($('#exit-survey-modal-b').length) {
    $('#exit-survey-modal-b').attr('class', 'modal show-confirm-box')
  } else {
    $('#exit-survey-modal').attr('class', 'modal show-confirm-box')
  }
}


export function playEmbedVideo() {
  $('.exit-video-thumb').on('click', function(event) {
    const divName = 'embed-video-div'
    const videoLink = 'https://media1.shenyun.com/video/2021/Audience%20Reviews.mp4'
    $(this).html(videoJsCode(divName, videoLink))
  })
}

function stopVideo () {
	const media = document.querySelector('.video-js')
	media.pause()
}


export function closeExitSurvey() {
  $('#ouibounce-modal').hide()
  if ($('.VideoWrapper').length) {
    // $('.exit-video-thumb').empty()
		stopVideo()
  }
}

const ExitSurvey = function() {
  exitSurveySelect()
  playEmbedVideo()
}

new ExitSurvey()

window.closeExitSurvey = closeExitSurvey
window.showConfirmBox = showConfirmBox
